import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { register } from "../../api/auth";
import { Button } from "../../components/Button";
import { authState, updateAuthUser } from "../../states/authState";
import { TextField } from "./TextField";

export interface RegisterFormProps {
}

export const RegisterForm: React.FC<RegisterFormProps> = (props) => {
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [password2, setPassword2] = useState("");
	const [marketing, setMarketing] = useState(false);
	const [loading, setLoading] = useState(false);
	const [errors, setErrors] = useState<Record<string, string[]>>();
	const navigate = useNavigate();

	const handleRegister = async (e: React.FormEvent) => {
		e.preventDefault();
		if (password !== password2) {
			setErrors({ password2: ["Passwords don't match"] });
			return;
		}
		setErrors(undefined);
		setLoading(true);
		const res = await register(email, password, marketing);
		setLoading(false);
		if (!res.ok) {
			setErrors(res.errors);
			return;
		}

		authState.accessToken = res.access_token;
		await updateAuthUser();
		navigate("/");
	};

	return (
		<div className={"flex flex-col w-64"}>
			<form onSubmit={handleRegister}>
				<div className={"flex flex-col mb-4"}>
					<TextField
						label={"Email"}
						value={email}
						onChange={setEmail}
						tabIndex={0}
						errors={errors?.["email"]}
					/>
					<TextField
						label={"Password"}
						type={"password"}
						value={password}
						onChange={setPassword}
						tabIndex={1}
						errors={errors?.["password"]}
					/>
					<TextField
						label={"Repeat Password"}
						type={"password"}
						placeholder={"Password"}
						value={password2}
						onChange={setPassword2}
						tabIndex={2}
						errors={errors?.["password2"]}
					/>
					<label className={"text-gray-300 mb-2"}>
						<input
							type={"checkbox"}
							className={"mr-2"}
							checked={marketing}
							tabIndex={3}
							onChange={(e) => setMarketing(e.currentTarget.checked)}
						/>
						Receive marketing emails
					</label>
					<a
						href={"https://docs.riftkit.net/docs/privacy/"}
						className={"text-blue-200 underline"}
						target={"_blank"}
						rel={"noreferrer noopener"}
					>
						Privacy Policy
					</a>
				</div>

				<div className={"flex justify-between items-center"}>
					{!loading && <Button
						type={"submit"}
						className={"px-6"}
						onClick={handleRegister}
						tabIndex={3}
					>
						Create Account
					</Button>}
					{loading && <div className={"text-slate-200"}>Loading...</div>}
					<div>
						<Link to={"/login"} className={"text-slate-200 mx-2"} tabIndex={4}>
							Login
						</Link>
					</div>
				</div>
			</form>
		</div>
	);
};
